import { Link } from "react-router-dom";

import { NV_PATHS, NvAlertDialog, NvButton, NvSkeleton } from "@/components/navigator";

// 북마크 · 비교함 · 최근 조회가 같이 쓰는 조각 (4열 카드 격자 · 불러오는 중 · 빈 상태의 다음 걸음 · 알림 팝업)

// 카드는 4열(282 · 간격 24)
export const CARD_GRID = "grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4";

export const RETRY_LATER = "잠시 후 다시 시도해 주세요.";

// Each section loads on its own and shows exactly one of: skeleton · [다시 시도] · empty · content
export function CardSkeletons() {
  return (
    <div aria-hidden className={CARD_GRID}>
      {[0, 1, 2, 3].map((i) => (
        <NvSkeleton key={i} className="h-[254px] rounded-nv-card" />
      ))}
    </div>
  );
}

export function FinderLink() {
  return (
    <NvButton variant="secondary" asChild>
      <Link to={NV_PATHS.agentFinder}>Agent Finder에서 찾아보기</Link>
    </NvButton>
  );
}

export function AlertPopup({ message, onClose }: { message: string | null; onClose: () => void }) {
  return <NvAlertDialog open={message !== null} onOpenChange={(o) => !o && onClose()} message={message ?? ""} actions={<NvButton onClick={onClose}>확인</NvButton>} />;
}
